/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Viewer_RetryInputs */

const vi_einvoice_viewer_retry = /** @type {(inputs: Einvoice_Viewer_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử tải lại`)
};

/**

* @param {Einvoice_Viewer_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_viewer_retry = /** @type {((inputs?: Einvoice_Viewer_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Viewer_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_viewer_retry(inputs)
});